module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai647-077c8032e8fd84e1908fec4b951c93a6.jpg";